import(/* webpackMode: "eager", webpackExports: ["CustomMarkdown"] */ "/codebuild/output/src63316654/src/craft-stadium/frontend/user/src/components/CustomMarkdown.tsx");
